<script setup>
import { partnerPage } from '@/graphql/queries/partner.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(partnerPage, variables)

if (!data.value.partner) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.partner)

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="partner-page p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-400-20 max">
      {{ page.titolo }}
    </p>
    <ListImageText
      v-if="page.listaIntro"
      :blocks="page.listaIntro"
      :title="page.titoloIntroPartner"
    />

    <OverlapBlock
      v-if="page.bloccoSovrapposto"
      :blocco-sovrapposto="page.bloccoSovrapposto"
      type="type2"
      :dark="true"
    />

    <div class="black-bg">
      <SwiperSlider
        v-if="
          data.azienda.caroselloClienti &&
          data.azienda.caroselloClienti.clienteSlide.length
        "
        class="p-top-7"
        :slides="data.azienda.caroselloClienti.clienteSlide"
        :title="data.azienda.caroselloClienti.titolo"
        type="clienti-type"
      />
      <PaginePartnerForm v-if="page" class="row-40-20" />
    </div>
  </div>
</template>
